import React from "react";
import ComparableGrid from "components/Homeowner/CaseForms/ComparableGrid/ComparableGrid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
class NewCompGridDemo extends React.Component {
  render() {
    return (
      <Card>
        <CardContent>
          <ComparableGrid controlNumber={13862326} isDemo={true} />
        </CardContent>
      </Card>
    );
  }
}

export default NewCompGridDemo;
